<template>
  <div class="company-details-forms flex">
    <div class="backButton" @click="goBack()">
      <img src="../../assets/LandingPage/backButton.svg" />
      <p>Create Account</p>
    </div>
    <div class="divider"></div>

    <div class="mainDiv">
      <div class="logo mb-10">
        <img src="@/assets/logo.svg" alt="" />
      </div>

      <v-form class="formDiv" @submit.prevent ref="companyDetailsFormRef">
        <div>
          <label class="--font">Company name</label>
          <v-textarea
            class="input"
            :disabled="loader"
            outlined
            placeholder="Describe your brand.."
            counter
            rows="4"
            height="50"
            maxlength="80"
            v-model="companyName"
             :rules="appliedRules"
          >
            <template v-slot:counter="{ props }">
              <div class="secondary-font counter">{{ props.value }}/80</div>
            </template>
          </v-textarea>

          <label class="--font">Company Mobile Number</label>
          <v-text-field
            class="input"
            outlined
            type="number"
            placeholder="10 digit Mobile no.."
            v-model="phonenumber"
             :rules="phoneAppliedRules"
          >
            <!-- <template v-slot:counter="{ props }">
                            <div class="secondary-font counter">{{ props.value }}/1000</div>
                        </template> -->
          </v-text-field>

          <label class="--font">Company category</label>
          <v-select
            class="input"
            :disabled="loader"
            :rules="appliedRules"
            outlined
            placeholder="Choose your brand type"
            :items="categories"
            item-text="name"
            item-value="id"
            v-model="selectedCategory"
          />

          <label class="--font">Write a bio</label>
          <v-textarea
            :disabled="loader"
            class="input"
            outlined
            placeholder="Describe your brand.."
            counter
            rows="4"
            height="100"
            maxlength="1000"
            v-model="bio"
          >
            <template v-slot:counter="{ props }">
              <div class="secondary-font counter">{{ props.value }}/1000</div>
            </template>
          </v-textarea>
        </div>

        <button
          class="nextButton white--text weight"
          @click.prevent="setCompanyDetails"
          :disabled="loader"
        >
          Next
          <v-progress-circular
            indeterminate
            size="13"
            class="mb-1"
            width="2"
            v-if="loader"
          />
        </button>
      </v-form>
    </div>
  </div>
</template>

<script>
import accessToken from "../../helpers/accessToken";
import API_URL from "../../helpers/apiUrls";
import rules from "../../helpers/rules";
import MoengageEventGenerator from "../../helpers/moengageEventGenerator";
import MoengageEvents from "../../helpers/moengageEvents";
import MoengageAtrributes from "../../helpers/moengageAttributes";
export default {
  name: "setupProfileDetails",

  data() {
    return {
      categories: [],
      phonenumber: null,
      selectedCategory: null,
      companyName: "",
      bio: "",
      rules: rules,
      appliedRules: [],
      
      phoneAppliedRules: [],
      loader: false,
    };
  },
  mounted() {
    this.checkDevices();
  },

  created() {
    this.getCompanyCategories();

    if (this.$store.state.mainStore.user.brand.brandID) {
      this.companyName = this.$store.state.mainStore.user.brand.name;
      this.bio = this.$store.state.mainStore.user.brand.description;
    }
  },

  methods: {
    gtagEventHandler(eventName, attributeValue) {
      this.$gtag.event(eventName, attributeValue);
    },
    checkDevices() {
      let details = navigator.userAgent;
      let regexp = /android|iphone|kindle|ipad/i;
      let isMobileDevice = regexp.test(details);

      this.isMobile = isMobileDevice;
    },
    goBack() {
      this.$router.go(-1);
    },
    getCompanyCategories() {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log(this.$store.state.mainStore.user);
          this.categories = response.data.brand_categories;
          this.selectedCategory =
            this.$store.state.mainStore.user.brand.categoryID;
        }
      };

      const errorHandler = (error) => {
        console.log(error.data);
      };

      this.requestGET(
        API_URL.brandCategories,
        {},
        {},
        successHandler,
        errorHandler
      );
    },

    setCompanyDetails() {
      this.appliedRules.push(this.rules.required);
      this.phoneAppliedRules.push(this.rules.validPhoneNumber);
      console.log('this.appliedRules',this.phoneAppliedRules);
      if (this.$refs.companyDetailsFormRef.validate()) {
        this.loader = true;
        const successHandler = (response) => {
          if (response.status === 201 || response.status === 200) {
            this.showToast("Brand has been successfully registered!");
            if (this.isMobile) {
              this.$router.push({ name: "setupProfileLogoMobile" });
              localStorage.setItem("Brand-ID", response.data.id);
              this.$store.state.mainStore.user.brand.brandID = response.data.id;
              this.$store.state.mainStore.user.brand.name = response.data.name;
              this.$store.state.mainStore.user.brand.description =
                response.data.description;
              this.$store.state.mainStore.user.brand.categoryID =
                response.data.brand_category;
              this.loader = false;
            } else {
              this.$router.push({ name: "setupProfileLogo" });
              localStorage.setItem("Brand-ID", response.data.id);
              this.$store.state.mainStore.user.brand.brandID = response.data.id;
              this.$store.state.mainStore.user.brand.name = response.data.name;
              this.$store.state.mainStore.user.brand.description =
                response.data.description;
              this.$store.state.mainStore.user.brand.categoryID =
                response.data.brand_category;
              this.loader = false;
            }
          }
        };

        const errorHandler = (error) => {
          this.showToast("Something went wrong!", "error", 10000);
          this.loader = false;
        };

        const data = {
          name: this.companyName,
          description: this.bio,
          brand_category: this.selectedCategory,
          phone_number:this.phonenumber
        };
        const moengageAttr = {
          [MoengageAtrributes.IsUserGenerated]: "TRUE",
          [MoengageAtrributes.Source]: "BSLandingPage",
          // [MoengageAtrributes.ButtonClicked]:"Log In with Email",
          [MoengageAtrributes.Device]: !this.isMobile ? "Desktop" : "Mobile",
          [MoengageAtrributes.LoginMode]: "Register with Gmail",
          [MoengageAtrributes.SignupResult]: "Success",
          [MoengageAtrributes.Platform]: "Web",
          [MoengageAtrributes.TabName]: "Register",
          [MoengageAtrributes.FieldEntered]: data,
        };
        MoengageEventGenerator(MoengageEvents.LoginPageAction, moengageAttr);
        this.gtagEventHandler(MoengageEvents.LoginPageAction, moengageAttr);

        const brandID = accessToken.getCredentials().brandID;

        const headers = {
          Authorization: `Bearer ${this.$store.state.mainStore.temporaryAccessToken}`,
          "BRAND-ID": brandID ? brandID : null,
        };

        if (brandID) {
          this.requestPATCH(
            `${API_URL.brand}/${brandID}/_partial_update`,
            data,
            headers,
            successHandler,
            errorHandler
          );
        } else {
          this.requestPOST(
            API_URL.brand,
            data,
            headers,
            successHandler,
            errorHandler
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.backButton {
  display: flex;
  margin-right: auto;
  padding-left: 20px;
  height: 64px;
  align-items: center;
  width: 100%;
  box-shadow: 1px 0px #000007;
  p {
    margin: 0px;
    margin-left: 13px;
    font-size: 18px;
    font-weight: 500;
  }
  @media all and (min-width: 1025px) {
    display: none;
  }
}
.formDiv {
  display: flex;
  flex-direction: column;
  height: 100%;
  @media all and (max-width: 1024px) {
    justify-content: space-between;
  }
}
.company-details-forms {
  height: 100vh;
  flex-direction: column;
  display: flex;
  @media all and (max-width: 1024px) {
    justify-content: space-between;
  }
}
.mainDiv {
  width: 25%;
  @media all and (max-width: 1024px) {
    width: 100%;
    padding: 20px;
    height: calc(100vh - 64px);
  }
}
.logo {
  @media all and (max-width: 1024px) {
    display: none;
  }
}
.input {
  margin-top: 10px;
  position: relative;
  z-index: 99;
}

.counter {
  font-size: 0.8rem;
}

button {
  width: 100%;
  padding: 15px 0;
  border-radius: 3px;
}
.nextButton {
  background-color: #1f8f58;
  @media all and (max-width: 1024px) {
    background-color: #339137;
  }
}
.divider {
  height: 2px;
  background: #f6f6f6;
  width: 100%;
  @media all and (min-width: 1024px) {
    display: none;
  }
}

button:disabled {
  opacity: 0.5;
}
</style>
